import { render } from "./MyTasksPanel.vue?vue&type=template&id=38807052&scoped=true&ts=true"
import script from "./MyTasksPanel.vue?vue&type=script&lang=ts"
export * from "./MyTasksPanel.vue?vue&type=script&lang=ts"

import "./MyTasksPanel.vue?vue&type=style&index=0&id=38807052&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38807052"]])

export default __exports__